import { useEffect, useRef, useState } from "react";
import { refreshEverything } from "@/lib/queryClient";

/* Live-verbinding (SSE): bij elke schrijfactie in de garage verversen alle schermen direct. Valt terug op polling als de verbinding wegvalt. */
export function useLiveEvents(enabled = true) {
  const [live, setLive] = useState(false);
  const es = useRef(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let stopped = false, retry = 2000;
    const connect = () => {
      if (stopped) return;
      const src = new EventSource(`${process.env.REACT_APP_BACKEND_URL}/api/events/stream`, { withCredentials: true });
      es.current = src;
      src.addEventListener("hello", () => { setLive(true); retry = 2000; });
      src.addEventListener("change", () => refreshEverything());
      src.onerror = () => { setLive(false); src.close(); if (!stopped) { setTimeout(connect, retry); retry = Math.min(retry * 2, 30000); } };
    };
    connect();
    return () => { stopped = true; es.current?.close(); };
  }, [enabled]);
  return live;
}
